import { Skeleton, Stack } from '@mantine/core';

export function ResponseProjectDetailAsideLoading() {
  return (
    <Stack
      bg="white"
      w="100%"
      p="04"
      spacing="02"
      sx={theme => ({
        boxShadow: theme.shadows.md,
        borderRadius: 20,
      })}
    >
      <Skeleton h={22} w="30%" radius="lg" />
      <Skeleton h={30} w="80%" radius="lg" />
      <Skeleton h={30} w="100%" radius="lg" />
      <Skeleton h={30} w="90%" radius="lg" />
    </Stack>
  );
}
